<div id="no-loans-section" class="font-normal py-5" *ngIf="(loanTiles === null)">
    <img src="../../../../../assets/images/empty-folder.svg" alt="No loans approved yet"/>
    <p class="mt-4">No loans approved yet</p>
</div>

<span class="mt-4 justify-content-center align-items-center" appDottedLoader [appShowLoaderUntil]="loanTiles"></span>
<div class="pt-2">
    <div *ngFor="let tile of loanTilesObservables | async" [ngClass]="{'faded': !isActiveLoan(tile) }" class="tile font-normal mt-2 d-lg-flex d-md-flex justify-content-lg-between justify-content-md-between ng-star-inserted text-left align-items-center">
        <div class="container-fluid m-0 p-0">
            <div class="d-lg-flex d-sm-flex">
                <div class="mr-lg-5 mr-sm-5 font-18">
                    <span class="mr-2">Loan ID:</span>
                    <span class="font-weight-bold">{{ tile.generatedLoanId }}</span>
                </div>
                <div class="mt-3 mb-3 mb-lg-0 mb-sm-0 mt-lg-0 mt-sm-0">
                    <span class="mr-2">Loan Reason:</span>
                    <span class="font-weight-bold">{{ tile.reason }}</span>
                </div>
            </div>
            <div class="d-flex flex-wrap mt-3">
                <div class="mr-5 m-0 p-0 loan-one-lined-details" style="min-width: 80px;">
                    <span>₹ </span>
                    <span class="font-weight-bold">{{ tile.amount | number : '1.2-2'}}</span>
                </div>
                <div class="mr-5 m-0 p-0 loan-one-lined-details" style="min-width: 93px">
                    <span class="mr-4">@</span>
                    <span class="font-weight-bold">{{ tile.roi }}%</span><span class="font-small faded"> p.a.</span>
                </div>
                <div *ngIf="tile.tenure !== undefined && tile.tenure !== null" class="m-0 p-0 mt-lg-0 mt-sm-0" style="min-width: 109px">
                    <span class="font-weight-bold mr-4 faded">for</span>
                    <span class="font-weight-bold">{{ tile.tenure }}</span><span class="font-small faded"> Months</span>
                </div>
            </div>
        </div>
        <div class="text-lg-right text-sm-right tile-action-cont">
            <div><span [ngStyle]="{'color': tile.colorCode}" class="font-xs-small font-sm-normal font-weight-bold">{{ tile.status }}</span></div>
            <div><a *ngIf="tile.redirection?.link" class="link-default font-xs-small font-sm-normal font-weight-bold" [routerLink]="tile.redirection?.link">
                {{ tile.redirection.label ? tile.redirection.label : 'click here'  }}</a></div>
        </div>
    </div>
    <div class="mt-4"  *ngIf="dataSource?.data?.length > defaultPageSize">
        <app-pagination [dataSource]="dataSource" [length]="dataSource.data.length" [pageSize]="defaultPageSize" [showTotalPages]="4"
                        [pageSizeOptions]="[defaultPageSize, defaultPageSize * 2, defaultPageSize * 4, defaultPageSize * 10]"></app-pagination>
    </div>
</div>
